import { Container } from 'react-bootstrap';
import { SmartImage } from '~/components/utils/SmartImage';

interface Props {
    src?: string;
    alt: string;
    cldUrl?: string;
}

export default function PageImage({ src, alt, cldUrl }: Props) {
    // This component is used to display images on the page
    return (
        <div className="position-relative" style={{ width: '100%', position: 'relative' }}>
            <Container style={{ position: 'relative', width: '100%', aspectRatio: '16 / 9', marginBottom: '30px' }}>
                {src ? (
                    <SmartImage
                        src={src}
                        alt={alt}
                        className="img-fluid"
                        widths={[640, 960]}
                        fit="cover"
                    />) : (
                    <SmartImage
                        cldUrl={cldUrl}
                        alt={alt}
                        className="img-fluid"
                        widths={[640, 960]}
                        fit="cover"
                    />
                )}
            </Container>
        </div>
    )
}

// activeCourse.largeImage || '/assets/img/defaultCourseDetails.jpeg'